import { useRouter } from "next/router";
import PropTypes from "prop-types";
import type { FC, ReactNode } from "react";
import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/use-auth";

interface GuestGuardProps {
  children: ReactNode;
}

export const GuestGuard: FC<GuestGuardProps> = (props) => {
  const { children } = props;
  const auth = useAuth();
  const router = useRouter();
  const [checked, setChecked] = useState(false);
  const disableGuard = router.query.disableGuard as string;

  useEffect(
    () => {
      if (!router.isReady) {
        return;
      }

      // You should remove the "disableGuard" check, because it's meant to be used only in the demo.
      const returnUrl = router?.query?.returnUrl;
      if (auth?.isAuthenticated && disableGuard !== "true" && returnUrl) {
        router.push(returnUrl as string);
      } else if (auth?.isAuthenticated && disableGuard !== "true") {
        router.push("/dashboard");
      } else {
        setChecked(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router.isReady]
  );

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // not authenticated / authorized.

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};
